export default {
  title: "Центр притяжения выставки «Металлообработка-2026»",
  greeting: "Уважаемые компании – участники выставки «Металлообработка-2026»!",
  intro: {
    paragraph1:
      "Ваше активное участие в привлечении аудитории на свой стенд – основа нашего взаимного успеха.",
    paragraph2:
      "Широкий информационный охват повышает вероятность для каждого участника найти новых клиентов, укрепить партнерские связи и заключить выгодные сделки. Ведь усилия по продвижению работают не только на общий интерес к событию, но и напрямую повышают отдачу от участия вашей компании в выставке.",
    highlight:
      "Мы ценим ваш вклад и предлагаем отметить его в рамках конкурса «Центр притяжения выставки «Металлообработка-2026»!"
  },
  howItWorks: {
    title: "Как это работает",
    content:
      "Используйте уникальную UTM-метку из личного кабинета в ваших коммуникациях – на сайте, в соцсетях, e-mail-рассылках и в работе с партнерами. Каждый билет, полученный с использованием вашей уникальной UTM-меткой увеличивает ваши шансы на победу и делает выставку еще более эффективной для вашего бизнеса. В последний день выставки организатор подводит итоги, и три компании, по UTM-меткам которых было получено наибольшее количество билетов, получают призы."
  },
  prizes: {
    title: "Призы для победителей",
    first: {
      badge: "1 место",
      title: "Главный приз",
      items: [
        "Почетное звание «Центр притяжения выставки «Металлообработка-2026»",
        "Диплом",
        "Умная колонка Яндекс.Станция 3"
      ],
      subtitle:
        "1-е место занимает участник, привлекший наибольшее количество посетителей, но не менее 300 человек"
    },
    second: {
      badge: "2 место",
      title: "Второе место",
      items: ["Диплом", "Яндекс.Станция Миди"],
      subtitle:
        "2-е место занимает участник, привлекший второе по величине количество посетителей, но не менее 200 человек"
    },
    third: {
      badge: "3 место",
      title: "Третье место",
      items: ["Диплом", "Яндекс.Станция Мини"],
      subtitle:
        "3-е место занимает участник, привлекший третье по величине количество посетителей, но не менее 100 человек"
    },
    subtitle:
      "В случае привлечении равного количества посетителей, победителем считается компания, которая первой достигла данных показателей."
  },
  closing: {
    paragraph1:
      "И главное – ваша активность поможет заполнить стенды заинтересованными специалистами, что станет лучшей наградой для всех участников.",
    downloadBanner: "Скачать баннер",
    highlight:
      "Давайте вместе создадим самое продуктивное событие в индустрии металлообработки!"
  },
  info: {
    datesLabel: "Сроки проведения конкурса:",
    datesValue: "1 апреля – 15 мая 2026 г.",
    resultsLabel: "Подведение итогов:",
    resultsValue: "15 мая 2026 г."
  },
  motto: "Работайте на свой успех. Мы поддерживаем ваши усилия.",
  agreement: {
    termsPrefix: "Я ознакомлен(а) и полностью соглашаюсь с условиями ",
    termsLink:
      "Положения о конкурсе «Центр притяжения выставки «Металлообработка-2026».",
    termsUrl: "/static/docs/contest/REGULATIONS_RUS.pdf",
    termsSuffix: ".",
    rules:
      "Я принимаю правила определения победителей на основе данных системы аналитики и обязуюсь использовать только разрешенные методы для привлечения посетителей."
  },
  button: {
    loading: "Получаем ссылку...",
    getLink: "Получить ссылку",
    participate: "Участвовать в конкурсе"
  },
  noContest: {
    title: "Активных конкурсов нет",
    text:
      "В настоящее время не проводится ни одного конкурса для участников. Следите за обновлениями в личном кабинете.",
    button: "Назад"
  },
  successPopup: {
    title: "Ссылка скопирована!",
    text: "Вы можете использовать ссылку для:",
    item1: "Размещения на сайте или в социальных сетях",
    item2: "Использования в email-рассылках",
    copy: "Скопировать ссылку"
  }
};
